import * as React from "react";
import {Grid} from "@mui/material";

export const Field = (props: any) => {
    const {type: Type, gridProps, wrapperProps, conditional, noWrapper, prop, ...rest} = props;

    if (conditional !== undefined && !conditional) {
        return null;
    }

    if (!!noWrapper) {
        return (
            <Type {...rest} />
        );
    }

    return (
        <Grid size={{ xs: 12, ...gridProps }} {...wrapperProps}>
            <Type {...rest} />
        </Grid>
    );
};

export const ContainerField = (props: any) => {
    const {gridProps, wrapperProps, conditional, children} = props;

    if (conditional !== undefined && !conditional) {
        return null;
    }

    return (
        <Grid size={{ xs: 12, ...gridProps }} {...wrapperProps}>
            {children}
        </Grid>
    );
};
